import { useState } from 'react';
import { Download, Share, Smartphone } from 'lucide-react';
import { usePwaInstall } from '../../hooks/usePwaInstall';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

function IosInstallDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Installa su iPhone o iPad</DialogTitle>
          <DialogDescription>
            Aggiungi l&apos;app alla schermata Home per aprirla come un&apos;applicazione nativa.
          </DialogDescription>
        </DialogHeader>
        <ol className="list-decimal space-y-3 pl-5 text-sm text-[var(--ba-body-text)]">
          <li className="pl-1">
            Tocca il pulsante <strong>Condividi</strong>{' '}
            <Share className="inline h-4 w-4 align-text-bottom" aria-hidden /> in basso (Safari).
          </li>
          <li className="pl-1">
            Scorri le opzioni e seleziona <strong>Aggiungi a Home</strong>.
          </li>
          <li className="pl-1">
            Conferma con <strong>Aggiungi</strong> in alto a destra.
          </li>
        </ol>
      </DialogContent>
    </Dialog>
  );
}

export default function InstallAppButton({ size = 'lg', variant = 'outline', className }) {
  const { installState, isVisible, platform, promptInstall } = usePwaInstall();
  const [iosGuideOpen, setIosGuideOpen] = useState(false);

  if (!isVisible) return null;

  const handleClick = async () => {
    if (installState === 'ios') {
      setIosGuideOpen(true);
      return;
    }
    await promptInstall();
  };

  const label =
    installState === 'ios'
      ? 'Aggiungi a Home'
      : platform === 'android'
        ? 'Installa app'
        : 'Installa sul dispositivo';

  const Icon = installState === 'ios' ? Share : platform === 'android' ? Smartphone : Download;

  return (
    <>
      <Button type="button" variant={variant} size={size} className={className} onClick={handleClick}>
        <Icon className="h-4 w-4" />
        {label}
      </Button>
      <IosInstallDialog open={iosGuideOpen} onOpenChange={setIosGuideOpen} />
    </>
  );
}
